import { render, staticRenderFns } from "./Produktmerkmale.vue?vue&type=template&id=65cc489a&scoped=true&"
import script from "./Produktmerkmale.vue?vue&type=script&lang=js&"
export * from "./Produktmerkmale.vue?vue&type=script&lang=js&"
import style0 from "./Produktmerkmale.vue?vue&type=style&index=0&id=65cc489a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc489a",
  null
  
)

export default component.exports